module.exports = __webpack_public_path__ + "img/Staffelführer.be8849f1.svg";